// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__2KbNg","label":"styles_label__2atvj","button":"styles_button__osNGR","caution":"styles_caution___i4Sr","permissionsInfo":"styles_permissionsInfo__1IPoh"};